/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Type-only re-exports of the agent/generate contract types used by the agent
 * client. Kept type-only so the browser-safe client pulls in no runtime code
 * from `@genkit-ai/ai`.
 *
 * @module beta/client/types
 */

export type {
  AgentInit,
  AgentInput,
  AgentOutput,
  AgentStreamChunk,
  GenerationUsage,
  MessageData,
  Part,
  ToolRequestPart,
  ToolResponsePart,
} from '@genkit-ai/ai';
export type {
  AgentFinishReason,
  Artifact,
  SessionSnapshot,
  SessionState,
} from '@genkit-ai/ai/session';
